export default "__VITE_ASSET__DfkTryzo__"